import { render, staticRenderFns } from "./MenuItemDetail.vue?vue&type=template&id=f98765f6"
import script from "./MenuItemDetail.vue?vue&type=script&lang=js"
export * from "./MenuItemDetail.vue?vue&type=script&lang=js"
import style0 from "./MenuItemDetail.vue?vue&type=style&index=0&id=f98765f6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports